import script from "./BlockViewer.vue?vue&type=script&setup=true&lang=ts"
export * from "./BlockViewer.vue?vue&type=script&setup=true&lang=ts"

import "./BlockViewer.vue?vue&type=style&index=0&id=c0c2ed00&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c0c2ed00"]])

export default __exports__